<template>
	<card-toolbar style="padding-bottom: 30px;">
		<div slot="left" class="buttons has-addons">
			<b-checkbox v-model="isHiddenContain" true-value="1" false-value="0" @input="onCheckboxClick">サービス停止中も含める</b-checkbox>
		</div>
	</card-toolbar>
</template>

<script>
	import CardToolbar from '@/components/CardToolbar'
	export default {
		name: "CustomerTableToolbar",
		components: {
			CardToolbar
		},
		data() {
			return {
				isHiddenContain: false,
			}
		},
		methods: {
			onCheckboxClick: function(val) {
				this.$emit('checkbox-click', val);
			}
		}
	}
</script>

<style scoped>

</style>
